<template>
  <div>
    <div class="product-color">
      <div
        class="alert alert-danger product-item__content--edit__error"
        role="alert"
        v-if="errors.length > 0"
      >
        <p v-for="error in errors" :key="error">{{error}}</p>
      </div>
      <div v-if="editFlag">
        <form class="uploadImg" @submit.prevent="handleEditImage($event)">
          <div class v-show="!selected">
            <button class="btn btn-primary" @click.prevent="toggleSelected">Select Image</button>
          </div>
          <div v-show="selected">
            <div class="d-none">
              <input type="file" accept="image/*" required @input="fileChange" />
            </div>
            <button type="submit" class="btn btn-primary" v-if="loading" disabled>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Loading
            </button>
            <button class="btn btn-primary m-r-5" type="submit" v-else>Confirm Image</button>
            <button class="btn btn-success" @click.prevent="()=>{selected = false}">Cancel</button>
          </div>
        </form>
      </div>
      <div v-else>
        <div>
          <div class="img-container">
            <img :src="img" />
          </div>
        </div>
        <div class="product-color__actions">
          <button class="btn btn-success" @click="toggleActive()">
            <i class="far fa-edit"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { globalStore } from '../../main.js';
import { herokuUrl } from "../../apiConfig";
import axios from "axios";
import { getCookie } from "../../cookie.js";
import logOut from "../../scripts/utils";

export default {
  props: ["metaId"],
  data() {
    return {
      editFlag: true,
      loading: false,
      errors: [],
      img: "",
      selected: false
    };
  },
  methods: {
    fileChange(e) {
      if (e.target.files[0]) {
        this.selected = true;
      } else {
        this.selected = false;
      }
    },
    toggleActive() {
      this.editFlag = !this.editFlag;
      this.loading = false;
    },
    toggleSelected(e) {
      // this.selected = !this.selected;
      e.target.parentNode.parentNode.getElementsByTagName("input")[0].click();
    },
    handleEditImage(e) {
      this.loading = true;

      this.errors.splice(0, this.errors.length);

      // create formdata, get all files and add them to form data, then send them to api
      var bodyFormData = new FormData();
      [...e.target.elements].forEach(item => {
        if (item.nodeName == "INPUT") {
          bodyFormData.append("images", item.files[0]);
        }
      });
      // console.log('emit')
      // this.$emit("addFabricImg", 'https://web-keyz.com/ithoob/uploads/product1.jpg',this.metaId);
      axios({
        method: "POST",
        url: `${herokuUrl}/upload`,
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: getCookie("user")
        }
      })
        .then(response => {
          if (response.data.status) {
            this.loading = false;
            this.toggleActive();
            this.img = response.data.sources;
            this.$emit("addFabricImg", response.data.sources, this.metaId);
          } else {
            this.errors.push("For files, large file upload is forbidden");
            this.errors.push(response.data.message);
          }
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            // console.log(err);
            this.loading = false;
            this.errors.push(err);
            this.errors.push("For files, large file upload is forbidden");    
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/_global.scss";

.product-color {
  background: #fff;
  border-radius: 10px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  .img-container{
    height:100px;
    width:100px;
    img {
      height: 100%;
      width: 100%;
    }
  }
  &__actions {
    width: fit-content;
    margin-top: 10px;
    button {
      cursor: pointer;
    }
  }
}
</style>
